import pb from '../lib/pocketbase';

export async function getCategoriasIva(page, perPage) {
  return await pb.collection('categoria_iva').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: '' // Ajusta si necesitas expandir relaciones
  });
}

export async function createCategoriaIva(categoriaIva) {
  return await pb.collection('categoria_iva').create(categoriaIva);
}

export async function updateCategoriaIva(id, categoriaIva) {
  return await pb.collection('categoria_iva').update(id, categoriaIva);
}

export async function deleteCategoriaIva(id) {
  return await pb.collection('categoria_iva').delete(id);
}
